import { useState } from 'react'

import { useSelector } from 'react-redux'

import { Box } from '@chakra-ui/react'

import {
  BadgeCounter,
  FilterIcon,
  IconButton,
  TABLE_MAX_WIDTH,
  TableToolbar,
} from '@hivewatch/dark'
import type { ColorScheme } from '@hivewatch/dark'

import { guardToursFilterCountSelector } from '@/redux/ui/uiSlice'

import { DarkGuardToursFilterDrawer } from '../guard-tours-filter-drawer/dark'

interface GuardToursTableToolbarIProps {
  colorScheme: ColorScheme
  filter: string
  setFilter: (value: string) => void
}

export const GuardToursTableToolbar = ({
  colorScheme,
  filter,
  setFilter,
}: GuardToursTableToolbarIProps) => {
  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false)

  const filterCount = useSelector(guardToursFilterCountSelector)

  return (
    <>
      <TableToolbar
        actions={
          <Box
            alignItems='center'
            cursor='pointer'
            display='flex'
            gap='8px'
            onClick={() => setIsFilterDrawerOpen(true)}
          >
            {filterCount > 0 && (
              <BadgeCounter
                colorScheme={colorScheme}
                count={filterCount}
                variant='button'
              />
            )}
            <IconButton
              aria-label='Filter'
              colorScheme={colorScheme}
              dimension={36}
              icon={<FilterIcon colorScheme={colorScheme} />}
            />
          </Box>
        }
        colorScheme={colorScheme}
        maxWidth={TABLE_MAX_WIDTH}
        onChange={setFilter}
        placeholder='Search guard tours'
        value={filter}
      />
      <DarkGuardToursFilterDrawer
        colorScheme={colorScheme}
        isOpen={isFilterDrawerOpen}
        onClose={() => setIsFilterDrawerOpen(false)}
      />
    </>
  )
}
